module.exports = __webpack_public_path__ + "img/start.66f17ddc.png";